export const getCurrentUser = (state) =>
  state.user && state.user.user ? state.user.user : null;

export const getCurrentUserEmail = (state) => getCurrentUser(state)?.email;

export default {
  getCurrentUser,
  getCurrentUserEmail,
};
